<button
  show-delay="200"
  placement="bottom"
  [ngClass]="[type, layout, size, iconUrl ? 'icon' : '']"
  [class.disable-btn]="disableBtn"
  [disabled]="disableBtn"
>
  <img *ngIf="iconUrl && !loading" src="{{ iconUrl }}" alt="ico" />
  <app-spinner *ngIf="loading"></app-spinner>
  <ng-content></ng-content>
</button>
